import { openPopup } from '../helpers';
import {
  checkHovering,
  showTaskDetails,
  markExtraEmployees,
  stylePopup,
  getDateFromEmployeeDay,
  getProjectId,
  getSupervisorId,
  openHover,
  showManagePlannedEmployeesPopup,
} from './shared';

$(document).ready(() => {
  $(document).on('click', '#tasks_planner_view .employee_hover', function () {
    const projectId = getProjectId($(this));
    const supervisorId = getSupervisorId($(this));
    const competencyId = getCompetencyId($(this));
    const taskId = getTaskId($(this));
    const taskClass = getTaskClass($(this));
    const date = getDateFromEmployeeDay($(this));
    const data = {
      project_id: projectId,
      supervisor_id: supervisorId,
      competency_id: competencyId,
      task_id: taskId,
      task_class: taskClass,
      date,
    };
    $.ajax({
      url: '/planned_employee_days/employees',
      type: 'GET',
      data,
      success(data) {
        const selector = '#employees_popup';
        const openCallback = function () {
          const requiredLabour = parseInt($(selector).find('#required_labour').val(), 10);
          const employees = $(selector).find('.assigned_to_task_employee');
          markExtraEmployees(employees, requiredLabour);
          $(selector).data('projectId', projectId);
          $(selector).data('supervisorId', supervisorId);
          $(selector).data('date', date);
          $(selector).data('competencyId', competencyId);
          $(selector).data('taskId', taskId);
          $(selector).data('taskClass', taskClass);
          stylePopup(selector);
        };
        const closeCallback = function () {
          $(selector).dialog('destroy');
          drawPlanner(false);
        };
        openPopup(selector, data, openCallback, closeCallback);
      },
    });
    return false;
  });

  function getTaskId(employeesCounter) {
    return employeesCounter.closest('.allocated').find('.task_template').first().data('taskId');
  }

  function getTaskClass(employeesCounter) {
    return employeesCounter.closest('.allocated').find('.task_template').first().data('taskClass');
  }

  function getCompetencyId(employeesCounter) {
    return employeesCounter.closest('.allocated').find('.task_template').first().data('competencyId');
  }

  $(document).on('mouseover', '#tasks_planner_view .employee_hover', function (event) {
    if (checkHovering(event, this)) {
      const context = this;
      const projectId = getProjectId($(this));
      const supervisorId = getSupervisorId($(this));
      const competencyId = getCompetencyId($(this));
      const taskId = getTaskId($(this));
      const taskClass = getTaskClass($(this));
      const date = getDateFromEmployeeDay($(this));
      const data = {
        project_id: projectId,
        supervisor_id: supervisorId,
        competency_id: competencyId,
        task_id: taskId,
        task_class: taskClass,
        date,
      };
      const callback = function () {
        hideElementsForEmployeesHoverPopup();
        const requiredLabour = parseInt($('#hover_popup #required_labour').val(), 10);
        const employees = $('#hover_popup .assigned_to_task_employee');
        markExtraEmployees(employees, requiredLabour);
      };
      $.ajax({
        url: '/planned_employee_days/employees',
        type: 'GET',
        data,
        success(data) {
          openHover(data, context, callback);
        },
      });
    }
  });

  function hideElementsForEmployeesHoverPopup() {
    $('#hover_popup #manage_employees').hide();
  }

  $(document).on('click', '#employees_popup #manage_employees', () => {
    const data = getDataForManagePlannedEmployeesPopup($('#employees_popup').data());
    $('#employees_popup').dialog('destroy');
    showManagePlannedEmployeesPopup(data);
  });

  function getDataForManagePlannedEmployeesPopup(dataAttributes) {
    return {
      date: dataAttributes.date,
      competency_id: dataAttributes.competencyId,
      project_id: dataAttributes.projectId,
      supervisor_id: dataAttributes.supervisorId,
      task_id: dataAttributes.taskId,
      task_class: dataAttributes.taskClass,
    };
  }

  $(document).on('click', '#manage_planned_employees_popup #toggle-other-employees', () => {
    $('#manage_planned_employees_popup #other_employees').toggle();
  });

  function getAssignedToPlannedTaskEmployees() {
    const notPersistedEmployeeIds = $('#manage_planned_employees_popup #not_persisted_employees .employee').filter(function () {
      return $(this).hasClass('planned') || $(this).hasClass('actual');
    }).map(function () {
      return $(this).data('id');
    }).toArray();
    const persistedEmployeeIds = $('#manage_planned_employees_popup #persisted_employees .employee').filter(function () {
      return !$(this).data('actual') && $(this).hasClass('actual');
    }).map(function () {
      return $(this).data('id');
    }).toArray();
    return notPersistedEmployeeIds.concat(persistedEmployeeIds);
  }

  function getDataForSavingPlannedEmployees() {
    const employeeIds = getAssignedToPlannedTaskEmployees();
    const requiredEmployees = $('#required_employees').val();
    let data = {};
    if ($('#manage_planned_employees_popup').is(':visible')) {
      data = dataForSavingPlannedEmployeesFromPopup($('#manage_planned_employees_popup'));
    } else {
      data = dataForSavingPlannedEmployeesFromPopup($('#employees_popup'));
    }
    data.employee_ids = employeeIds;
    data.employee_ids_for_unassign = employeeIdsForUnassign();
    data.required_employees = requiredEmployees;
    return data;
  }

  function employeeIdsForUnassign() {
    return $('#manage_planned_employees_popup #persisted_employees .employee').filter(function () {
      const wasActual = $(this).data('actual');
      const wasPlanned = $(this).data('planned');
      const isActual = $(this).hasClass('actual');
      const isPlanned = $(this).hasClass('planned');
      return employeeIsForUnassign(wasActual, wasPlanned, isActual, isPlanned);
    }).map(function () {
      return $(this).data('id');
    }).toArray();
  }

  function employeeIsForUnassign(wasActual, wasPlanned, isActual, isPlanned) {
    const previousState = [wasActual, wasPlanned].filter((el) => el);
    const currentState = [isActual, isPlanned].filter((el) => el);
    return currentState.length < previousState.length;
  }

  function dataForSavingPlannedEmployeesFromPopup(popup) {
    const plannedFrom = popup.data('plannedFrom') || popup.data('date');
    const plannedTo = popup.data('plannedTo') || popup.data('date');
    const taskId = popup.data('taskId');
    const taskIds = popup.data('taskIds') || [taskId];
    const taskClass = popup.data('taskClass');
    return {
      task_ids: taskIds,
      task_class: taskClass,
      date: popup.data('date'),
      planned_from: plannedFrom,
      planned_to: plannedTo,
      project_id: popup.data('projectId'),
      supervisor_id: popup.data('supervisorId'),
      competency_id: popup.data('competencyId'),
    };
  }

  $(document).on('click', '#manage_planned_employees_popup #save_employees', () => {
    const data = getDataForSavingPlannedEmployees();
    $.ajax({
      url: 'planned_employee_days/manage_planned_employees',
      type: 'PUT',
      data,
      success(data) {
        if (data.status === 'ok') {
          $('#manage_planned_employees_popup').dialog('destroy');
          if ($('#planner-mobile').length) {
            const date = $('#manage_planned_employees_popup').data('date');
            const taskId = $('#manage_planned_employees_popup').data('taskId');
            const competencyId = $('#manage_planned_employees_popup').data('competencyId');
            const projectId = $('#manage_planned_employees_popup').data('projectId');
            const supervisorId = $('#manage_planned_employees_popup').data('supervisorId');
            const task = findTaskMobile(date, projectId, supervisorId, competencyId, taskId);
            const expandableArea = task.find('.expandable_area');
            showTaskDetails(expandableArea);
          } else {
            $('#employees_popup').remove();
            drawPlanner(false);
          }
          $('body').css({ overflow: 'inherit' });
        }
      },
    });
    return false;
  });

  function findTaskMobile(date, projectId, supervisorId, competencyId, taskId) {
    return $('.task_mobile').filter(function () {
      const task = $(this);
      const competencyIdMatched = (task.data('competencyId') === competencyId) && (competencyId > 0);
      const taskIdMatched = (task.data('taskId') === taskId) && (taskId > 0);
      return (task.data('projectId') === projectId)
             && (task.data('supervisorId') === supervisorId)
             && (task.data('date') === date)
             && (competencyIdMatched || taskIdMatched);
    });
  }

  $(document).on('click', '#manage_planned_employees_popup .employee', function () {
    const dateStr = $('#manage_planned_employees_popup').data('date');
    const date = $.datepicker.parseDate('dd/mm/yy', dateStr);
    const onlyPlannedEmployees = $('#manage_planned_employees_popup').data('onlyPlannedEmployees');
    let classForDay = date <= new Date() ? 'actual' : 'planned';
    if (onlyPlannedEmployees) { classForDay = 'planned'; }
    if (!$(this).hasClass(classForDay)) {
      $(this).addClass(classForDay);
      $(this).removeClass('for_destroy');
      return;
    }
    if ($(this).hasClass('actual') && $(this).hasClass('planned')) {
      $(this).removeClass('actual');
    } else {
      $(this).removeClass(classForDay);
    }
    $(this).addClass('for_destroy');
  });

  $(document).on('click', '.task_mobile #manage_employees', function (e) {
    e.stopPropagation();
    const task = $(this).closest('.task_mobile');
    const data = getDataForManagePlannedEmployeesPopup(task.data());
    showManagePlannedEmployeesPopup(data);
  });

  $(document).on('keyup', '#search_for_employee', function () {
    const regexp = new RegExp($(this).val(), 'i');
    filterUIElementsByMatchedText(regexp, '.employee');
  });

  function filterUIElementsByMatchedText(regexp, selectorOfElementsForFiltering) {
    const callback = function (el, regexp) {
      const elementText = $(el).text();
      if (regexp.test(elementText)) {
        $(el).show();
      } else {
        $(el).hide();
      }
    };
    filterUIElements(regexp, selectorOfElementsForFiltering, callback);
  }

  function filterUIElements(regexp, selector, callback) {
    $(selector).each(function () {
      callback(this, regexp);
    });
  }
});
